import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";

export const useDeleteNotes = (
  onSuccess?: void | ((data: any) => void),
  onError?: void | ((error: any) => void)
) => {
  const queryClient = useQueryClient();
  const axios = useAxios();
  const { t } = useTranslation();
  return useMutation({
    mutationFn: async (id: string) => {
      const response = await axios.delete(`${t("notes")}/${id}`);
      return response.data;
    },
    onSuccess: (data, variables) => {
      if (onSuccess) {
        onSuccess(data);
      }
      queryClient.setQueriesData(
        { queryKey: ["notes-list"] },
        (oldData: any) => {
          if (!oldData) return oldData;
          // variables is the id passed to mutate
          return oldData.filter((note: any) => note.id !== variables);
        }
      );
    },
    onError: (err) => {
      if (onError) {
        onError(err);
      }
    }
  });
};
